import React from 'react'
import { useFormContext } from 'react-hook-form'
import { FormErrorMessage, Text } from '@chakra-ui/core'
import { StyledFormControl, StyledFormLabel } from 'components/AdminConsole/commonUI/styles'
import useLocaleText from 'components/useLocaleText'
import { ALargeSmall } from 'lucide-react'
import { InputWithIcon } from 'components/AdminConsole/commonUI/InputWithIcon'
import { getNestedError, MAX_TITLE_LENGTH } from '../utils'

interface TitleFieldProps {
  maxLength?: number
  error_title_length?: string
  requireNonBlank?: boolean
}

export const TitleField: React.FC<TitleFieldProps> = ({
  maxLength = MAX_TITLE_LENGTH,
  error_title_length,
  requireNonBlank = false,
}) => {
  const { register, errors } = useFormContext()
  const t = useLocaleText('pop_title', true)
  const t_placeholder = useLocaleText('pop_title_placeholder', true)
  const error_title = useLocaleText('error_title', true)
  const error_title_max_length = useLocaleText('error_title_max_length', true)

  const error = getNestedError(errors, 'data.pop_title')

  const validationRules = {
    required: error_title,
    ...(requireNonBlank && { validate: (value: string) => !!value?.trim() || error_title }),
    maxLength: {
      value: maxLength,
      message: error_title_length || error_title_max_length,
    },
  }

  return (
    <StyledFormControl isInvalid={!!error} w="100%">
      <StyledFormLabel required>
        <ALargeSmall size={18} strokeWidth={2.5} />
        <Text>{t}</Text>
      </StyledFormLabel>
      <InputWithIcon name="data.pop_title" ref={register(validationRules)} placeholder={t_placeholder} />
      <FormErrorMessage>{error?.message}</FormErrorMessage>
    </StyledFormControl>
  )
}
